import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main content grid */}
        <div className="footer-content">
          {/* Branding */}
          <div className="footer-branding">
            <img src="/images/aslLogo2026.png" alt="All Seasons Landscaping" />
            <p className="footer-tagline">Premium Landscaping Since 1990</p>
          </div>

          {/* Featured Services */}
          <div className="footer-column">
            <h4>Featured</h4>
            <ul>
              <li><Link to="/LandscapeConstruction">Landscape Construction</Link></li>
              <li><Link to="/TreeFarm">Tree Services</Link></li>
              <li><Link to="/Snow">Snow Removal</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/TeamPage">About & Team</Link></li>
              <li><Link to="/TeamPage#positions">Careers</Link></li>
              <li><Link to="/Maintenance">Maintenance</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="footer-column">
            <h4>Connect</h4>
            <div className="footer-contact-item">
              <a href="mailto:info@allseasons.info">info@allseasons.info</a>
            </div>
            <div className="footer-contact-item">
              <a href="tel:2087883352">(208) 788-3352</a>
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61588567298492" aria-label="Facebook">
                <svg viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61588567298492" aria-label="Instagram">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} All Seasons Landscaping</span>
          <span><Link to="/PrivacyPolicy">Privacy Policy</Link></span>
          <span><Link to="/TermsConditions">Terms & Conditions</Link></span>
        </div>
      </div>
    </footer>
  );
}